import React, { useState } from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import { ImCross } from "react-icons/im";
// import { word_file_icon } from "../../../constant/imagePath";
import classes from "./AddVideoGallery.module.css";
import ReactPlayer from "react-player";
import { empty_video_thumbnail } from "../../constant/imagePath";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "../../Component/Button/Button";
import { Post } from "../../Axios/AxiosFunctions";
import { apiHeader, BaseURL } from "../../config/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { appendSingleVideo } from "../../store/common/commonSlice";

const AddVideoGallery = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFile, setIsFile] = useState(null);
  const [isVideFile, setVideFile] = useState(null);
  const [videoProgress, setVideoProgress] = useState(0);
  const [isUploading, setIsUploading] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const state = useSelector((state) => state.authReducer);
  const { access_token } = useSelector((state) => state.authReducer);

  const validateFileType = (file) => {
    const acceptedTypes = [
      "video/mp4",
      ".mkv",
      ".avi", // .video file extention list
    ];
    const fileType = file.type;

    if (acceptedTypes.includes(fileType)) {
      return false;
    } else {
      return toast.warn("Please Add Video");
    }
  };

  const handlePresignedApiCall = async (e) => {
    // const params = {
    //   fileSizeInKbs: e?.file?.size / 1000,
    //   fileName: e?.file?.name.split(".")[0],
    //   extension: "." + e?.file?.name.split(".")[1],
    // };
    setIsUploading("file");
    setIsLoading(true);

    const response = await Post(
      BaseURL("gallery"),
      {},
      apiHeader(access_token)
    );
    if (response == undefined) {
      setIsUploading("");
    }
    !!response?.data?.data?.url &&
      (await axios
        .put(response?.data?.data?.url, e, {
          headers: {
            "Content-Type": e?.type,
          },
          onUploadProgress: (data) => {
            setVideoProgress(Math.round((100 * data.loaded) / data.total));
          },
        })
        .then(() => {
          toast.success("File Uploaded Successfully.");
          setVideoProgress(0);
          setIsUploading("");
          navigate("/all-videos");
          dispatch(appendSingleVideo(response?.data?.data?.doc));
          //   dispatch(updateUser(response?.data?.data?.user));
          //   setAllFolders((prev) => [response?.data?.data?.file, ...prev]);
        })
        .catch(async (e) => {
          toast.error("File Not Uploaded");
          setVideoProgress(0);
          setIsUploading("");
        }));
    setIsLoading(false);
  };

  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {`${Math.round(videoProgress)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <SideBarSkeleton>
        <Container
          //   style={{
          //     overflow: step == 2 && "auto",
          //     height: step == 2 && " 100vh",
          //     paddingBottom: step == 2 && "130px",
          //   }}
          className="custom_conti_b"
        >
          <Row style={{ justifyContent: "center" }}>
            <Col md={8}>
              <div className={classes.height_box}>
                {!isFile ? (
                  <>
                    <Dropzone
                      validator={validateFileType}
                      //   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      //   accept=".docx"
                      //   accept={{ "application/msword": [] }}
                      // noClick={true}
                      //   disabled={true}
                      onDrop={(acceptedFiles) => {
                        setIsFile(URL.createObjectURL(acceptedFiles[0]));
                        setVideFile(acceptedFiles[0]);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section className={classes.uploadBox}>
                          <div
                            className={classes.input_box}
                            style={{
                              display: isFile && "flex",
                              alignItems: isFile && "center",
                            }}
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            {isFile?.length > 0 ? (
                              <div className={classes.div_main}>
                                <div
                                  className={classes.cross_icon}
                                  onClick={() => setIsFile([])}
                                >
                                  <ImCross />
                                </div>
                                {/* <img src={word_file_icon} /> */}
                              </div>
                            ) : (
                              <div className={classes.empty_video_div}>
                                <div className={classes.img_div_thumbail}>
                                  <img src={empty_video_thumbnail} />
                                </div>
                                <h4>Drag & Drop</h4>
                                <h4>
                                  Or <span>Browse</span>
                                </h4>
                              </div>
                            )}
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </>
                ) : (
                  <>
                    <div className={classes.video_tag}>
                      {/* {isFile && (
              <ReactPlayer
              
                // width={300}
                // height={300}
                url={isFile}
                style={{
                  width: "178px !important",
                  height: "160px !important",
                }}
              />
            )} */}
                      <video
                        autoplay
                        src={isFile}
                        width="750"
                        height="500"
                        controls
                      ></video>
                    </div>
                  </>
                )}
              </div>
              <div
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                }}
              >
                <div className="text-center mt-4 mb-4">
                  {videoProgress > 0 && (
                    <CircularProgressWithLabel value={videoProgress} />
                  )}
                </div>

                {isFile && isVideFile && (
                  <Button
                    label={"Clear Selection"}
                    onClick={() => {
                      setIsFile("");
                      setVideFile("");
                    }}
                    className="me-2"
                  />
                )}
                <Button
                  disabled={isLoading}
                  onClick={(e) => {
                    if (isVideFile) {
                      handlePresignedApiCall(isVideFile);
                    } else {
                      toast.warn("Please Add Video");
                    }
                  }}
                  green
                  label={isLoading ? "Please Wait..." : "Submit"}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </SideBarSkeleton>
    </>
  );
};

export default AddVideoGallery;
